import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings.js";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class WarehouseDamageService {
  constructor(private http: GenericHttpService) {}

  fetchData(param): Observable<any> {
    const config = {
      method: "GET",
      url: param.api,
      query: param.params
    };

    return this.http.httpRequest(config).pipe(
      catchError(this.http.handleError),
      map(this.processData)
    );
  }

  processData(data: any) {}

  createChart(chart, options) {
    return HSET.CHARTDATA;
  }
}
